/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import './MyStyles/style.css';
import './MyStyles/mobile-style.css';
import './MyStyles/site.css';
import './MyStyles/site2.css';

export const Footer = () => {
    return (
        <>
            <footer className="b-watcho-f">
                <div className="row">
                    <div className="col-md-6">
                    <p>©2019 Watcho. All Rights Reserved. www.watcho.com or abbreviated Watcho is an online video streaming service where visitors can access a variety of films, web series, Live TV serials, user generated content, etc., for which viewing rights are given by content copyright holders. Watcho and all related channel and programming logos are service marks of, and all related programming audio-visuals and elements are the property of Dish Infra Services Private Limited.</p>
                    </div>
                    <div className="col-md-6">
                        <div className="w-app-logo">
                            <span>TV<br/> Platforms</span>
                            <ul>
                                <li>
                                    <a target="_blank" href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.watcho_multi&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921629696%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=HWc2lqNoCI%2Bcc8Z%2B%2BPiJPZv4geUGUgdl4afUWrzIYyM%3D&reserved=0">
                                        <img alt="androidtv" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-android-tv.png" />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.amazon.in%2FWatcho-Original-Spotlight-Exclusive-Shows%2Fdp%2FB07XPG5FW5&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7Ca2f0a735c90c41f989a008dce75865ed%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638639614099960778%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=qUFxHyACDUi0X8bR2kyd93%2Bp29MYaSwFAFIoncjq1to%3D&reserved=0">
                                        <img src="Images/DKDOffer/f-logo2.svg" alt="" />
                                    </a>
                                </li>

                                <li>
                                    <a target="_blank" href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapps.apple.com%2Fin%2Fapp%2Fwatcho-new-web-series-livetv%2Fid1440733653%3Fplatform%3DappleTV&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921647310%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=k9hbgGbarb8nkl9cpto5zL6tFyKH3OwNhpMXAh60rI4%3D&reserved=0">
                                        <img alt="apple" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-apple-tv.png" />
                                    </a>
                                </li>

                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://www.samsung.com/levant/tvs/smart-tv/smart-hub-and-apps/">
                                        <img src="Images/DKDOffer/f-logo4.svg" alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://in.lgappstv.com/main/tvapp/detail?appId=1227441">
                                        <img src="Images/DKDOffer/f-logo5.svg" alt="" />
                                    </a>
                                </li>

                            </ul>
                        </div>
                        <div className="w-app-logo">
                            <span>Mobile <br /> Platforms</span>
                            <ul>
                                <li>
                                    <a target="_blank" href="https://apps.apple.com/in/app/watcho-original-web-shows/id1440733653"><img alt="iosapp" className="img-responsive " src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-ios-2.png"/></a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.watcho"><img alt="android-mobile" className="img-responsive " src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-android-mobile.png"/></a>
                                </li>
                            </ul>
                        </div>
                        <div className="w-app-logo">
                            <span>Set-Top-<br /> Box</span>
                            <ul>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://www.dishtv.in/">
                                        <img src="Images/dishTV-logo_New.png" alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://www.d2h.com/">
                                        <img src="Images/DKDOffer/f-logo9.svg" alt="" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer><section className="bottom_links">
                <ul>
                    <li><a href="https://www.watcho.com/privacy-policy" target="_blank">Privacy Policy</a></li>
                    <li><a href="https://www.watcho.com/terms-use" target="_blank">Terms &amp; Conditions</a></li>
                    <li><a href="https://www.watcho.com/grievance" target="_blank">Grievance</a></li>
                    <li><a href="https://www.watcho.com/cookies" target="_blank">Cookies</a></li>
                    <li><a href="https://www.watcho.com/about-us" target="_blank">About Us</a></li>
                    <li><a href="https://faq.watcho.com/" target="_blank">FAQ</a></li>
                </ul>
                <div className="w-share">
                    <div className="sharing">
                        <span>Connect with us :</span>
                    </div>
                    <ul>
                        <li>
                            <a target="_blank" href="https://www.facebook.com/LetsWatcho/"><img alt="facebook" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-facebook-follow.svg"/></a>
                        </li>
                        <li><a target="_blank" href="https://www.instagram.com/watchoapp/"><img alt="instagram" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-instagram-follow.svg"/></a></li>
                        <li>
                            <a target="_blank" href="https://x.com/watchoapp"><img alt="twitter" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-twitter-follow.svg"/></a>
                        </li>
                        <li>
                            <a target="_blank" href="https://www.youtube.com/channel/UCs_VbCkjjq5x5yGFgY6tAPg"><img alt="youtube" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-youtube-follow.svg"/></a>
                        </li>
                    </ul>
                </div>
            </section>

        </>
       
    );
}